import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormMetricsCommentItem } from 'services/models/form-builder/form-metrics/chart-data/comments-chart-data.model';
import { FormMetricsCommentsChartData } from 'services/models/form-builder/form-metrics/chart-data/comments-chart-data.model';
import { FormMetricsRespondentAnswerItemModel } from 'services/models/form-builder/form-metrics/form-metrics-drilldown.model';
import { FormMetricsItemModel } from 'services/models/form-builder/form-metrics/form-metrics-item.model';
import { commentsFromHighlightAnswers } from '../../utils/form-metrics-drilldown.util';

export interface FormMetricsCommentPreviewItem extends FormMetricsCommentItem {
  isHighlighted?: boolean;
}

@Component({
  selector: 'app-form-metrics-comments-widget',
  templateUrl: './form-metrics-comments-widget.component.html',
  styleUrls: ['./form-metrics-comments-widget.component.scss'],
})
export class FormMetricsCommentsWidgetComponent implements OnChanges {
  @Input() item: FormMetricsItemModel;
  @Input() highlightedEmployeeId: string | null = null;
  @Input() highlightAnswers: FormMetricsRespondentAnswerItemModel[] = [];
  @Output() viewAll = new EventEmitter<FormMetricsItemModel>();

  preview: FormMetricsCommentPreviewItem[] = [];
  totalComments = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['item'] ||
      changes['highlightedEmployeeId'] ||
      changes['highlightAnswers']
    ) {
      this.refreshPreview();
    }
  }

  onViewAll(): void {
    this.viewAll.emit(this.item);
  }

  private refreshPreview(): void {
    if (!this.highlightedEmployeeId) {
      this.applyDashboardPreview();
      return;
    }

    this.applyHighlightPreview();
  }

  private applyDashboardPreview(): void {
    const data = this.item?.chartData as FormMetricsCommentsChartData;
    this.preview = (data?.preview || []).map(comment => ({ ...comment, isHighlighted: false }));
    this.totalComments = data?.totalComments || 0;
  }

  private applyHighlightPreview(): void {
    const highlighted = commentsFromHighlightAnswers(
      this.highlightAnswers,
      this.item?.formItemId
    ).map(comment => ({ ...comment, isHighlighted: true }));

    this.preview = highlighted;
    this.totalComments = highlighted.length;
  }
}
